/**
 * Refuse to open a plaintext WebSocket where it would leak credentials.
 *
 * Both WS clients send the access token in their auth handshake, so a
 * `ws://` socket in production would ship that token in cleartext. This
 * guard fails loud on config drift (e.g. an http:// API base producing
 * a ws:// socket). Relative / no-scheme URLs are allowed — the browser
 * resolves them against the page origin (wss on an https page), which
 * is also the local-dev + Playwright `routeWebSocket` path.
 */
export function assertSecureWebSocketURL(
  url: string,
  opts: { forbidPlaintext: boolean },
): void {
  if (opts.forbidPlaintext && url.slice(0, 5).toLowerCase() === 'ws://') {
    throw new Error(
      `Refusing to open a plaintext (ws://) WebSocket when secure transport is required: ${url}`,
    );
  }
}
